import { Sidebar } from "flowbite-react"
import { AiFillDashboard } from "react-icons/ai"
import { FaAws, FaFlask, FaGraduationCap, FaUserAlt } from "react-icons/fa"
import { BsFillTicketPerforatedFill, BsUiChecks } from "react-icons/bs"
import { Link } from "react-router-dom"
import { useState } from "react"
import NavbarAdmin from "../navbar/NavbarAdmin"

const AdminSidebar = () => {
  const [collapsed, setCollapsed] = useState<boolean>(true)
  return (
    <>
      <NavbarAdmin
        collapseSidebar={() => {
          setCollapsed(!collapsed)
        }}
      />
      <Sidebar
        className={
          "fixed top-0 left-0 z-30 w-64 h-screen pt-20 transition-transform !bg-neutral-900 !dark:bg-neutral-900 sm:translate-x-0" +
          (collapsed ? " -translate-x-full" : " translate-x-0")
        }
        theme={{
          root: {
            inner: "",
          },
        }}
        aria-label="Sidebar"
      >
        <div className="h-full px-3 py-4 overflow-y-auto !bg-neutral-900 !dark:bg-neutral-900">
          <Sidebar.Items>
            <Sidebar.ItemGroup>
              <Sidebar.Item
                as={Link}
                to="/admin"
                icon={AiFillDashboard}
                className="flex items-center justify-center rounded-lg p-2 text-base font-normal hover:bg-neutral-700 text-white dark:hover:bg-neutral-700"
              >
                Dashboard
              </Sidebar.Item>
              <Sidebar.Item
                as={Link}
                to="/admin/users"
                icon={FaUserAlt}
                className="flex items-center justify-center rounded-lg p-2 text-base font-normal hover:bg-neutral-700 text-white dark:hover:bg-neutral-700"
              >
                Users
              </Sidebar.Item>
              <Sidebar.Item
                as={Link}
                to="/admin/courses"
                icon={FaGraduationCap}
                className="flex items-center justify-center rounded-lg p-2 text-base font-normal hover:bg-neutral-700 text-white dark:hover:bg-neutral-700"
              >
                Courses
              </Sidebar.Item>
              <Sidebar.Item
                as={Link}
                to="/admin/labs"
                icon={FaFlask}
                className="flex items-center justify-center rounded-lg p-2 text-base font-normal hover:bg-neutral-700 text-white dark:hover:bg-neutral-700"
              >
                Labs
              </Sidebar.Item>
              <Sidebar.Item
                as={Link}
                to="/admin/exams"
                icon={BsUiChecks}
                className="flex items-center justify-center rounded-lg p-2 text-base font-normal hover:bg-neutral-700 text-white dark:hover:bg-neutral-700"
              >
                Exams
              </Sidebar.Item>
              <Sidebar.Item
                as={Link}
                to="/admin/vouchers"
                icon={BsFillTicketPerforatedFill}
                className="flex items-center justify-center rounded-lg p-2 text-base font-normal hover:bg-neutral-700 text-white dark:hover:bg-neutral-700"
              >
                Vouchers
              </Sidebar.Item>
              <Sidebar.Item
                as={Link}
                to="/admin/aws_accounts"
                icon={FaAws}
                className="flex items-center justify-center rounded-lg p-2 text-base font-normal hover:bg-neutral-700 text-white dark:hover:bg-neutral-700"
              >
                AWS Accounts
              </Sidebar.Item>
            </Sidebar.ItemGroup>
          </Sidebar.Items>
        </div>
        {/* </aside> */}
      </Sidebar>
    </>
  )
}

export default AdminSidebar
